import { ITypedReduxAction } from '../../types/redux/actionType';
import { TUser } from '../../types/user';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EUserActionTypes {
  SetUser = 'user/SET',
}

type TSetUser = ITypedReduxAction<EUserActionTypes.SetUser, TUser>;

export type TUserActions = TSetUser;

export const setUser: (user: TUser) => TSetUser = actionGenerator<EUserActionTypes.SetUser, TUser>(
  EUserActionTypes.SetUser,
);
